var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isEnd ? 'p-3 mb-n3' : 'mx-auto my-3 rounded overflow-hidden',style:({ 'max-width': _vm.isEnd ? '' : '640px'})},[(_vm.fakeImageSrc)?_c('img',{class:_vm.isEnd ? 'rounded w-100' : 'w-100',attrs:{"src":_vm.fakeImageSrc}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }